export const USER_SETTING_SAVE_REQUEST = 'USER_SETTING_SAVE_REQUEST';
export const saveUserSetting = (setting) => ({
  type: USER_SETTING_SAVE_REQUEST,
  setting,
});

export const USER_SETTING_SAVE_GRID_CONFIG = 'USER_SETTING_SAVE_GRID_CONFIG';
export const saveUserSettingGridConfig = (gridType, statusViewId, filterViewId, gridConfig) => {
  const statefulConfig = gridConfig.map((c) => ({
    id: c.id,
    index: c.index,
    width: c.width,
    pinned: c.pinned,
    sorted: c.sorted,
    ...(c.shown === false ? { shown: false } : {}),
  }));
  return {
    type: USER_SETTING_SAVE_GRID_CONFIG,
    gridType,
    statusViewId,
    filterViewId,
    gridConfig: statefulConfig,
  };
};

export const USER_SETTING_SAVE_REQUEST_SUCCESS = 'USER_SETTING_SAVE_REQUEST_SUCCESS';
export const saveUserSettingSuccess = (setting) => ({
  type: USER_SETTING_SAVE_REQUEST_SUCCESS,
  setting,
});

export const UPDATE_USER_SETTING = 'UPDATE_USER_SETTING';
export const updateUserSetting = (setting) => ({
  type: UPDATE_USER_SETTING,
  setting,
});

export const UPDATE_USER_SETTINGS_BULK = 'UPDATE_USER_SETTINGS_BULK';
export const updateUserSettingsBulk = (newSettings) => ({
  type: UPDATE_USER_SETTINGS_BULK,
  newSettings,
});

export const CURRENT_USER_HYDRATE = 'CURRENT_USER_HYDRATE';
export const hydrateCurrentUser = () => ({
  type: CURRENT_USER_HYDRATE,
});

export const CURRENT_USER_GET_REQUEST = 'CURRENT_USER_GET_REQUEST';
export const getCurrentUser = (store) => ({
  type: CURRENT_USER_GET_REQUEST,
  store,
});

export const CURRENT_USER_GET_SUCCESS = 'CURRENT_USER_GET_SUCCESS';
export const getCurrentUserSuccess = (currentUser) => ({
  type: CURRENT_USER_GET_SUCCESS,
  currentUser,
});

export const UPDATE_USERS_LIST = 'UPDATE_USERS_LIST';
export const updateUsersList = (users) => ({
  type: UPDATE_USERS_LIST,
  users,
});
